
import React from 'react';
import { UCAModule, CommonModule } from "uca-react-containers-library";

const PaymentMethodsComponent = () => {
    const { saveRouteData } = CommonModule.useRoute();
    const { appData } = CommonModule.useApp();
    const heading = !appData.isBusinessBanner ?  'Payment & receipts' : 'Payment Methods';
   
    React.useEffect(() => {
        saveRouteData({ 'currentPage': heading });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
            <CommonModule.ViewportProvider>
                <div class="col-lg-3 col-xl-3">
                    <UCAModule.LeftNavigation></UCAModule.LeftNavigation>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9">
                    <UCAModule.PaymentMethods />
                </div>
            </CommonModule.ViewportProvider>
    );
};

export default PaymentMethodsComponent;





